import { DateTime } from "luxon"

export function getShipmentNotesTodayLine() {
    return DateTime.now().toLocaleString(DateTime.DATE_MED)
}

/** Strip trailing ephemeral date/whitespace lines before compare, load, or save. */
export function cleanShipmentNotesForComparison(notes) {
    let cleaned = (notes ?? "").trimEnd()
    const today = getShipmentNotesTodayLine()
    const todayOnlyLine = new RegExp(`^${today}$`, "i")

    while (cleaned.length > 0) {
        const lines = cleaned.split("\n")
        const lastLineTrimmed = lines[lines.length - 1].trim()

        if (lastLineTrimmed === "" || todayOnlyLine.test(lastLineTrimmed)) {
            cleaned = lines.length === 1 ? "" : lines.slice(0, -1).join("\n")
            continue
        }
        break
    }
    return cleaned
}

export function shipmentNotesFromApi(notes) {
    return cleanShipmentNotesForComparison(notes ?? "")
}

export const prepareShipmentNotesForSave = cleanShipmentNotesForComparison

export function hasShipmentNotesChanges(apiNotes, localNotes) {
    return cleanShipmentNotesForComparison(apiNotes) !== cleanShipmentNotesForComparison(localNotes)
}

export function beginShipmentNotesEditing(notes) {
    const editing = (`${notes}\n${getShipmentNotesTodayLine()}`).trim()
    return `${editing} `
}
